module.exports = __webpack_public_path__ + "img/Nicotiana_tabacum.9478bfc1.jpg";